export default function home(state={}, action) {
    switch(action.type) {
        case 'HOME_PERFORMANCE_START':
        case 'HOME_PERFORMANCE_FAILURE':
        case 'HOME_PERFORMANCE_SUCCESS':
            return {
                ...state,
                performanceReport : performanceReport(state.performanceReport, action)
            }
        default:
            return state;
    }
}

function performanceReport(state = {}, action) {
    switch(action.type) {
        case 'HOME_PERFORMANCE_START' :
            return {
                fetching : true,
                data : [],
                error : null,
            }
        case 'HOME_PERFORMANCE_FAILURE' :
            return {
                fetching : false,
                data : [],
                error : action.error,
            }
        case 'HOME_PERFORMANCE_SUCCESS' :
            return {
                fetching : false,
                data : action.data,
                error : null,
            }
        default:
            return state;
    }
}




/** WEBPACK FOOTER **
 ** ./src/reducers/home.js
 **/